// import type { ProductConfig } from "../mistral"
import img1 from "./itens-de-seguranca/1.png"
import img2 from "./itens-de-seguranca/2.png"
import img3 from "./itens-de-seguranca/3.png"
import img4 from "./itens-de-seguranca/4.png"
import img5 from "./itens-de-seguranca/5.png"
import img6 from "./itens-de-seguranca/6.png"
import img7 from "./itens-de-seguranca/7.png"
import img8 from "./itens-de-seguranca/8.png"
import img9 from "./itens-de-seguranca/9.png"
import img10 from "./itens-de-seguranca/10.png"
import { PublicHash } from "./public-hash"
import { QrCodeQueryLoading } from "./qr-code-query-loading"

export const imagens = [img1, img2, img3, img4, img5, img6, img7, img8, img9, img10]

import type { ProductConfig } from "../type"
import FavIcon from "./assets/com-fav.png"
import Logo from "./assets/logo.webp"
import Seal from "./assets/seal.webp"
import LandingPage from "./LandingPage"
import { SealMask } from "./seal-mask"

export const ngConfig: ProductConfig = {
	product: {
		name: "NG",
		domains: ["ng.primi.com.br", "www.ng.primi.com.br", "ng.homol.primi.com.br", "www.ng.homol.primi.com.br"],
		description:
			"Gerencie os selos de autenticidade do seu produto com numeração sequencial. Cada produto possui seu selo único com controle de lotes numerados.",
	},
	LandingPage,
	Logo,
	SealMask,
	QrCodeQueryLoading,
	FavIcon,
	Seal,
	PublicHash,
	theme: {
		colors: {
			cssVariables: {
				"--primary": "oklch(0.3905 0.0958 290.8)",
			},

			fallback: {
				primary: "purple-900",
				secondary: "amber-300",
				accent: "orange-400",
				background: "from-purple-50 to-amber-50",
				cardBackground: "from-amber-50 to-orange-50",
			},
		},
		fonts: {
			heading: "font-bold",
			body: "font-normal",
		},
	},
	securityItems: [
		{
			title: "Holografia Exclusiva de Alta Segurança",
			description:
				"Holografia exclusiva com elementos de segurança únicos com microtextos, imagem latente, alternância de imagens e cores.  Apresenta alternância entre as palavras “VÁLIDO” , “ORIGINAL” e  “OK” e logo personalizado do cliente.",
			image: imagens[0],
		},
		{
			title: "Holografia de Segurança Alta Segurança com Micro Relevo",
			description: "Aplicação de micro relevo personalizado sensível ao tato e com efeito numismático.",
			image: imagens[1],
		},
		{
			title: "Numeração Sequencial Indelével",
			description:
				"Identificação única por selo, aplicada de forma permanente e indelével, para controle e rastreabilidade.",
			image: imagens[2],
		},
		{
			title: "Código Randômico Indelével",
			description:
				"Código único e permanente impresso no selo de segurança, que funciona como uma hash pública. Ele pode ser comparado pelo usuário com as informações do sistema após o escaneamento do selo, garantindo autenticidade. Esse código está vinculado a uma hash privada armazenada de forma segura no sistema, impedindo falsificações.",
			image: imagens[3],
		},
		{
			title: "Micro Marcação na Holografia",
			description:
				"Repetição do mesmo código variável de validação na forma de micro marcação de forma indelével e pericial.",
			image: imagens[4],
		},
		{
			title: "QR Code com Efeito Opticamente Variável",
			description:
				"QR Code variável e único por selo, aplicado de forma indelével e permanente com efeito opticamente variável com variações de cor, tonalidade e cintilância conforme o ângulo de visualização.",
			image: imagens[5],
		},
		{
			title: "Impressão Iridescente Reagente a Luz UV",
			description:
				"Impressão com pigmentação especial que apresenta cintilância conforme o ângulo de visualização, com reflectância a luz UV na cor azul.",
			image: imagens[6],
		},
		{
			title: "Impressão Invisível Reagente a Luz UV",
			description: "Impressão não visível a luz ambiente reagente a luz UV na cor amarela.",
			image: imagens[7],
		},
		{
			title: "Fundo Numismático",
			description:
				"Fundo composto de linhas contínuas personalizadas criando uma imagem que transmite a sensação de relevo e de tridimensionalidade, resultante de micro-imagens que se deformam para constituir a imagem de primeiro plano.",
			image: imagens[8],
		},
		{
			title: "Componente Anti-Violação",
			description: "Aplicação de faqueamento interno que impede a remoção e reaproveitamento do selo sem sua violação.",
			image: imagens[9],
		},
	],
	settings: {
		enableQRCode: true,
		enableMap: true,
		enableReports: true,
		maxSealsPerBatch: 5000,
		enablePublicHash: true,
	},
}
